import type { Appointment, SyncConflict } from "@/lib/types.js";
import { deriveBanners } from "@/lib/banners.js";
import { Banner } from "@/components/ui/banner.js";

/**
 * Renders REQ-035 banners for an appointment, given the open conflict list.
 */
export function BannerStack({
  appointment,
  conflicts,
  onResolveSyncConflict
}: {
  appointment: Appointment;
  conflicts: SyncConflict[];
  onResolveSyncConflict?: (conflictId: string, resolution: "accept" | "reject") => void;
}): React.JSX.Element | null {
  const banners = deriveBanners(appointment, conflicts);
  if (banners.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      {banners.map((b) => (
        <Banner
          key={`${b.kind}:${b.appointment_id}:${b.conflict_id ?? ""}`}
          kind={b.kind}
          title={b.title}
          description={b.description}
          action={
            b.kind === "sync_conflict" && b.conflict_id && onResolveSyncConflict ? (
              <div className="flex gap-1">
                <button
                  type="button"
                  className="rounded border px-2 py-0.5 text-xs hover:bg-accent"
                  onClick={() => onResolveSyncConflict(b.conflict_id!, "accept")}
                >
                  Accept external
                </button>
                <button
                  type="button"
                  className="rounded border px-2 py-0.5 text-xs hover:bg-accent"
                  onClick={() => onResolveSyncConflict(b.conflict_id!, "reject")}
                >
                  Reject
                </button>
              </div>
            ) : null
          }
        />
      ))}
    </div>
  );
}
